module.exports = __webpack_public_path__ + "assets/delete.75333dc74ce8965879d6bc8c573e435a.png";